import React, {useContext} from 'react';
import {TemplateContext} from "./TemplateContext";
import DefaultTitle from "../nav/DefaultTitle";
import LessonTitle from "../nav/LessonTitle";

const Title = props => {
    const {titleComponentName} = useContext(TemplateContext);
    const {callback} = props;

    const titleComponents = {
        DefaultTitle: DefaultTitle,
        LessonTitle: LessonTitle
    };
    const TitleComponent = titleComponentName === undefined ? undefined : titleComponents[titleComponentName];

    if(TitleComponent === undefined) {
        return null;
    }

    return (
        <header className={'ch-title js-title'}>
            <TitleComponent/>
        </header>
    )
}

export default Title;